import { Step } from 'types/step';

interface GetPartialMessage {
  action: 'get_partial';
  data: string;
}

interface ValidationErrorMessage {
  type: 'validation_error';
}

interface EvaluateMessage {
  action: 'evaluate';
  data: Step;
}

export type MaestroWSMessage =
  | GetPartialMessage
  | ValidationErrorMessage
  | EvaluateMessage;

export function isGetPartialMessage(
  message: MaestroWSMessage
): message is GetPartialMessage {
  return 'action' in message && message.action === 'get_partial';
}

export function isValidationError(
  message: MaestroWSMessage
): message is ValidationErrorMessage {
  return 'type' in message && message.type === 'validation_error';
}
